/**
 * Formats a date string or number to a readable Spanish date string.
 * Returns an empty string for invalid input.
 * @param input - Date string or timestamp
 * @returns Formatted date string (e.g., '25 de abril de 2025')
 */
export function formatDate(input: string | number): string {
	const date = new Date(input)
	if (isNaN(date.getTime())) return ''
	return date.toLocaleDateString('es-ES', {
		month: 'long',
		day: 'numeric',
		year: 'numeric',
	})
}
